module.exports = __webpack_public_path__ + "img/1.a2dcf5f2.png";